import { render, staticRenderFns } from "./verify-email.vue?vue&type=template&id=7a312251"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"
import style0 from "./verify-email.vue?vue&type=style&index=0&id=7a312251&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a312251')) {
      api.createRecord('7a312251', component.options)
    } else {
      api.reload('7a312251', component.options)
    }
    module.hot.accept("./verify-email.vue?vue&type=template&id=7a312251", function () {
      api.rerender('7a312251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/registration/verify-email.vue"
export default component.exports